module.exports = __webpack_public_path__ + "static/media/Ellipse_green.4fc4e381.svg";